<template>
  <div class="about">    <!-- About Section -->
    <section id="about" class="about section">

      <!-- Section Title -->
      <div class="container section-title" data-aos="fade-up">
        <h2>{{ title }}<br></h2>

        
      </div><!-- End Section Title -->

      <div class="container">

        <div class="row gy-4">
          <div class="col-lg-4 position-relative align-self-start" data-aos="fade-up" data-aos-delay="100">
            <img src="assets/gudang/2.png" class="img-fluid rounded" alt="FWI">
            <a href="https://drive.google.com/file/d/1f0zwXlYgI3bQLRe4iWdlJJxeqiWh5a5Z/preview" class="glightbox pulsating-play-btn" target="_blank"></a>
          </div>
          <div class="col-lg-8 content" data-aos="fade-up" data-aos-delay="200" style="text-align: justify;">
            <h3>{{ text.pt }}</h3>
            <p class="fst-italic">
              {{ text.Isi }}
            </p>
            <ul class="list-unstyled">
              <li class="d-flex align-items-start mb-2">
                <i class="bi bi-check2-all me-2"></i>
                <span>{{ text.visi }}</span>
              </li>
              <li class="d-flex align-items-start mb-2">
                <i class="bi bi-check2-all me-2"></i>
                <span>{{ text.misi }}</span>
              </li>
              <li class="d-flex align-items-start">
                <i class="bi bi-check2-all me-2"></i>
                <span>{{ text.passion }}</span>
              </li>
            </ul>
          </div>
        </div>

      </div>

    </section><!-- /About Section -->
    <!-- Stats Section -->
    <section id="stats" class="stats section">

      <div class="container " data-aos="fade-up" data-aos-delay="100">

        <div class="row gy-4 justify-content-center">

          <div class="col-lg-4 col-md-6" v-for="item in dataFasilitas" :key="item.id">
            <div class="stats-item d-flex align-items-center w-100 h-100">
              <i :class="item.icon" class="flex-shrink-0"></i>
              <div class="ms-3">
                <span data-purecounter-start="0" data-purecounter-end="25" data-purecounter-duration="1" class="purecounter fs-5"></span>
                <h5 class="mt-1">{{ item.name }}</h5>
                <p class="mt-2 text-muted">{{ item.description }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>

    </section><!-- /Stats Section -->
      <!-- <div class="milestone-wrapper">
        <section id="featured-champion" class="milestone section">
          <div class="container">
            <div class="section-title" data-aos="fade-up">
              <h2>Pencapaian</h2>
            </div>
            <div class="row gy-4 justify-content-center">
              <div class="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="100" v-for="(item, index) in dataMilestone" :key="index">
                <div class="milestone-item position-relative d-flex flex-column align-items-center">
                  <div class="icon rounded-circle p-3 mb-3">
                    <i :class="item.icon" style="font-size: 2rem;"></i>
                  </div>
                  <h4 class="mb-2">
                    <p>{{ item.year }}</p>
                  </h4>
                  <p class="text-center">{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> -->
  </div>
</template>

<script>
import AboutJs from './js/app.js';
export default AboutJs;
</script>